// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentHybridEnrollmentRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentHybridEnrollmentRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentHybridEnrollmentRequestModel.discriminator = undefined;
ExtEnrollmentHybridEnrollmentRequestModel.additionalProperties = false;
ExtEnrollmentHybridEnrollmentRequestModel.attributeTypeMap = [
    {
        "name": "cardInfo",
        "baseName": "cardInfo",
        "type": "ExtEnrollmentCardInfoModel"
    },
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "ExtEnrollmentMedBenInsuranceVerificationModel"
    },
    {
        "name": "survey",
        "baseName": "survey",
        "type": ""
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentMedBenEnrollmentDemographicsModel"
    },
    {
        "name": "guardianInfo",
        "baseName": "guardianInfo",
        "type": "ExtEnrollmentGuardianInfoModel"
    },
];
//# sourceMappingURL=extEnrollmentHybridEnrollmentRequestModel.js.map